import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaGithub, FaCode } from 'react-icons/fa';

const Projects = ({ projects }) => {
  const defaultProjects = [
    {
      _id: '1', title: 'E-Commerce Store', description: 'Full-featured online store with payment integration, user authentication, and admin dashboard.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Stripe'], liveUrl: '#', githubUrl: '#'
    },
    {
      _id: '2', title: 'Social Media App', description: 'Real-time social media platform with posts, likes, comments, and messaging.',
      technologies: ['React', 'Express', 'Socket.io', 'MongoDB'], liveUrl: '#', githubUrl: '#'
    },
    {
      _id: '3', title: 'Task Manager', description: 'Collaborative task management tool with drag-and-drop, deadlines, and team features.',
      technologies: ['React', 'Node.js', 'PostgreSQL'], liveUrl: '#', githubUrl: '#'
    }
  ];

  const displayProjects = projects.length > 0 ? projects : defaultProjects;

  return (
    <section className="projects section" id="projects">
      <div className="container">
        <div className="section-title">
          <h2>My Projects</h2>
          <p>Some things I've built</p>
        </div>
        <div className="projects-grid">
          {displayProjects.map((project, idx) => (
            <motion.div
              key={project._id}
              className="project-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.15 }}
            >
              <div className="project-image">
                <FaCode />
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies?.map((tech, i) => (
                    <span key={i}>{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.liveUrl && (
                    <a href={project.liveUrl} target="_blank" rel="noreferrer" title="Live Demo">
                      <FaExternalLinkAlt />
                    </a>
                  )}
                  {project.githubUrl && (
                    <a href={project.githubUrl} target="_blank" rel="noreferrer" title="Source Code">
                      <FaGithub />
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
